export default class AppAside extends HTMLDivElement {

    constructor() {
        super()
        this.$view = this
        this.$bodyWrapper = document.querySelector('.body-wrapper')
        this.$foldAside = this.querySelector('.js-fold-aside')
        this.$toggleAside = document.querySelectorAll('.js-toggle-app-aside')
        this.$mainNav = this.querySelector('.js-main-nav')
    }

    connectedCallback() {

        if (localStorage.getItem('app-aside-state') === null) {
            localStorage.setItem('app-aside-state', 'expanded')
        } else if (localStorage.getItem('app-aside-state') === 'folded') {
            this.$bodyWrapper.classList.add('app-aside-folded')
            this.classList.add('folded')
        }

        this.$foldAside.addEventListener('click', (e) => {
            this.toggleState()
        })

        this.$view.addEventListener('mouseenter', (e) => {
            if (localStorage.getItem('app-aside-state') === 'folded') {
                this.classList.remove('folded')
            }
        })

        this.$view.addEventListener('mouseleave', (e) => {
            if (localStorage.getItem('app-aside-state') === 'folded') {
                this.classList.add('folded')
            }
        })

        for (const toggle of this.$toggleAside) {
            toggle.addEventListener('click', (e) => {
                e.preventDefault()
                this.classList.toggle('opened')
            })
        }

        for (const subNav of this.$mainNav.querySelectorAll('li > ul')) {
            const listItem = subNav.parentElement
            const link = subNav.previousElementSibling
            link.addEventListener('click', (e) => {
                listItem.classList.toggle('opened')
            })
        }

    }

    toggleState() {
        if (localStorage.getItem('app-aside-state') === 'expanded') {
            this.$bodyWrapper.classList.add('app-aside-folded')
            this.classList.add('folded')
            localStorage.setItem('app-aside-state', 'folded')
        } else {
            this.$bodyWrapper.classList.remove('app-aside-folded')
            this.classList.remove('folded')
            localStorage.setItem('app-aside-state', 'expanded')
        }
    }



}